import React from 'react'
import Image from 'next/image'
import {motion} from 'framer-motion'

import {logEvent} from '@lib/gtm'
type HeroProps = {
  animationProps: (delay?: number) => {
    initial: {
      opacity: number
      y: number
    }
    animate: {
      opacity: number
      y: number
    }
    transition: {
      duration: number
      ease: number[]
      delay: number
    }
  }
  scrollTo: (e: React.MouseEvent<HTMLAnchorElement>) => void
}
export const Hero = ({animationProps, scrollTo}: HeroProps) => {
  return (
    <section className='DataLabeling__hero'>
      <div className='DataLabeling__hero__container'>
        <img
          className='DataLabeling__hero__container__circle'
          alt='Data Labeling'
          src='/images/services/data-labeling/circle-bg.svg'
        />
        <div className='DataLabeling__hero__container__img'>
          <motion.div {...animationProps(0.1)}>
            <img
              className='DataLabeling__hero__container__img__circle'
              alt='Data Labeling'
              src='/images/services/data-labeling/circle-bg.svg'
              style={{position: 'absolute'}}
            />

            <Image
              alt='Data Labeling'
              src='/images/services/data-labeling/hero.png'
              width='440px'
              height='532px'
              priority
            />
          </motion.div>
        </div>
        <div className='DataLabeling__hero__container__content'>
          <h1 className='DataLabeling__hero__container__content--desktop'>
            บริการ<span> Data Labeling</span>
            <br /> ระดับ
            <span> มืออาชีพ </span>
            <br />
            ข้อมูลมีคุณภาพ <br />
            พร้อมใช้งาน
            <span> ทุกธุรกิจ</span>
          </h1>
          <h1 className='DataLabeling__hero__container__content--mobile'>
            บริการ <span>Data Labeling</span>
            <br /> ระดับ
            <span> มืออาชีพ </span>
            ข้อมูลมีคุณภาพ <br />
            พร้อมใช้งาน
            <span> ทุกธุรกิจ</span>
          </h1>

          <motion.a
            {...animationProps(0.3)}
            href='#contact'
            onClick={(e) => {
              scrollTo(e)
              logEvent({
                ga: {
                  category: 'Data Labeling',
                  action: 'Action: Click CTA',
                },
              })
            }}
            className='DataLabeling__hero__container__content__button'
          >
            ปรึกษาฟรี
          </motion.a>
        </div>
      </div>
    </section>
  )
}
